import { SelectionTool } from '../../tools/tool-selection';
import Feature from 'ol/Feature';
import { mapWrapper } from '@pages/map/map';


export class AreaSelection<T> {
    public selectionTool: SelectionTool;

    constructor(layerSource, onSelect: (items: T[]) => void) {
        this.selectionTool = new SelectionTool(mapWrapper, layerSource, (hits: Feature[]) => {
            const hitsData: any[] = hits.map(f => f.get('data'));

            if (hitsData.length === 0) {
                this.selectionTool.clear();
            }

            onSelect(hitsData);
        });
    }

    activate() {
        this.selectionTool.activate();
    }

    deactivate() {
        if (this.selectionTool) {
            this.selectionTool.deactivate();
        }
    }

    clear = () => this.selectionTool.clear();
}
